import React from "react";
import {TextArea} from "semantic-ui-react";
import {OptionBasicCoreDto} from "../../../../services/Client";
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import AutoTextArea from "react-textarea-autosize";

interface OnClickInputProps extends IVirtualizedTableCellComponentProps {}

export const OnClickInput: React.SFC<OnClickInputProps> = (props: OnClickInputProps) => {
    const handleOnClick = () => {
        if(props.readOnly || !props.onCellClick) {
            return;
        }

        props.onCellClick();
    };

    const payload: OptionBasicCoreDto[] = props.value;
    const value = payload && payload.length > 0 ?
        payload.map((ob: OptionBasicCoreDto) => ob.pccdPackageContent).join(" ") : "";
    if (props.editDialogHeader && (props.editDialogHeader.editingColumn === 'Package Content' || props.editDialogHeader.editingColumn === 'Paketinhalt')) {
        return (
            <div onClick={handleOnClick}>
                <div
                    // @ts-ignore already checked in first if
                    style={{
                        width: "100%",
                        height:'85px',
                        border:'0.5px solid rgba(34, 36, 38, 0.15)',
                        overflow:'auto',
                        opacity:'0.45',
                        borderRadius:'.28571429rem'
                    }}
                >
                    {payload.map((ob: OptionBasicCoreDto,index:number) =>
                        <p
                            style={{
                                margin: 3
                            }}
                            key={`${ob.objectId}-${index}`}
                        >
                            {ob.pccdPackageContent}
                        </p>)
                    }
                </div>
            </div>
        );
    }

    return (
        <div onClick={handleOnClick}>
            {props.uglyMode
                ?
                <AutoTextArea
                    disabled={true}
                    value={value ? value : ""}
                    style={{
                        width: "100%",
                        resize: 'none',
                    }}
                />
                :
                <TextArea
                    value={value}
                    disabled={props.readOnly}
                    className={props.readOnly ? "onClickInputDisabled" : "onClickInputEnabled"}
                />
            }
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Table/components/modalDropdown/OnClickInput.tsx